var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('perfil-editar-form',{on:{"success":_vm.success}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }